import React from 'react';
import { Link } from 'react-router-dom';
import '../mobile_landing/MobileLandingPage.css'; // reuse some base tokens if needed
import './MobileBlogPage.css';

// Single hardcoded post for now mirroring desktop BlogPage welcome post.
const welcomePost = {
  id: 'welcome',
  title: 'An introduction to DocuHounds',
  excerpt:
    'DocuHounds was founded at Boston College by founders with engineering and software backgrounds. DocuHounds Student is a student-first platform that automates syllabus parsing, calendar population, and task organization — launching in 2026 for New England campuses.',
  image: '/blog/welcome.png',
  date: 'October 16, 2025'
};

const betaLaunchPost = {
  id: 'beta-launch',
  title: 'DocuHounds Beta Is Live',
  excerpt:
    'Today we officially opened DocuHounds to the public. After spending the last year building, testing, and refining this platform, we\'re excited to finally launch the DocuHounds beta and put it in the hands of real users.',
  image: '/blog/DocuHounds_beta_live.png',
  date: 'January 12, 2026'
};

const ambassadorPost = {
  id: 'ambassador-program',
  title: 'The DocuHounds Ambassador Program Is Live',
  excerpt:
    'Alongside the beta launch, we\'re officially rolling out the DocuHounds Ambassador Program. This program is about bringing real students into the process early and building DocuHounds the right way.',
  image: '/blog/DocuHounds_ambassador_program.png',
  date: 'February 2, 2026'
};

const builtForPost = {
  id: 'who-docuhounds-is-built-for',
  title: 'Who DocuHounds Is Built For',
  excerpt:
    'DocuHounds was built for the students whose education has to coexist with real life. Work schedules. Commutes. Family responsibilities. Financial pressure. Students who care deeply about school because the stakes are high.',
  image: '/blog/Who_DocuHounds_is_built_for.png',
  date: 'February 8, 2026'
};

export default function MobileBlogPage(){
  // Additional posts can be added here; exclude the featured welcome post from grid to avoid duplication.
  const posts = [builtForPost, ambassadorPost, betaLaunchPost];

  return (
    <div className="mobile-blog-page">
      <header className="mbp-header">
        <Link to="/" className="mbp-home-btn icon-only" aria-label="Return to home">
          <svg className="mbp-home-ic" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
            <defs>
              <linearGradient id="homeGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#2142ff"/>
                <stop offset="50%" stopColor="#69b2ff"/>
                <stop offset="100%" stopColor="#f8cc72"/>
              </linearGradient>
            </defs>
            <path d="M4 11.5 12 5l8 6.5v6.2c0 .9-.7 1.6-1.6 1.6H5.6c-.9 0-1.6-.7-1.6-1.6v-6.2Z" fill="url(#homeGrad)" stroke="rgba(15,32,58,0.15)" strokeWidth="1" strokeLinejoin="round"/>
            <path d="M9.75 19.3v-4.1c0-.7.55-1.2 1.25-1.2h2c.7 0 1.25.5 1.25 1.2v4.1" fill="none" stroke="#fff" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" opacity="0.85"/>
          </svg>
        </Link>
        <h1 className="mbp-title">DocuHounds Blog</h1>
        <p className="mbp-subtitle">Stories, updates, and insights from the builders of DocuHounds.</p>
        <div className="mbp-accent" />
        <div className="mbp-powered">Powered by <span className="scout-mark">Scout</span></div>
      </header>

      <section className="mbp-featured">
           <Link to={`/m/blog/${welcomePost.id}`} className="mbp-featured-card">
          <div className="mbp-featured-media">
            <img
              src={welcomePost.image}
              alt="featured"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = '/logos/blue_docuhounds_text.png';
              }}
            />
          </div>
          <div className="mbp-featured-body">
            <h2 className="mbp-featured-title">{welcomePost.title}</h2>
            <p className="mbp-featured-excerpt">{welcomePost.excerpt}</p>
            <span className="mbp-featured-cta mbp-cta-pill">Read more</span>
          </div>
        </Link>
      </section>

      {posts.length > 0 && (
        <section className="mbp-grid" aria-label="Articles">
          {posts.map(p => (
            <article key={p.id} className="mbp-article">
              <Link to={`/m/blog/${p.id}`} className="mbp-article-link">
                <div className="mbp-thumb">
                  <img
                    src={p.image}
                    alt={p.title}
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = '/logos/blue_docuhounds_text.png';
                    }}
                  />
                </div>
                <div className="mbp-article-body">
                  <div className="mbp-date">{p.date}</div>
                  <h3 className="mbp-article-title">{p.title}</h3>
                  <p className="mbp-article-excerpt">{p.excerpt}</p>
                  <span className="mbp-read mbp-cta-pill">Read Article →</span>
                </div>
              </Link>
            </article>
          ))}
        </section>
      )}
    </div>
  );
}
